import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { useAuth } from "@/shared/auth/useAuth";
import { Button } from "@/shared/components/ui/button";
import { LocaleSwitcher } from "./LocaleSwitcher";
import { firstInitial } from "./first-initial";

export function Topbar() {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();
  const initial = firstInitial(user?.displayName, user?.email);

  return (
    <header
      data-testid="topbar"
      className="flex h-20 flex-shrink-0 items-center justify-between border-b bg-card px-8"
    >
      <div className="flex items-center gap-3">
        <div
          aria-hidden
          data-testid="topbar-avatar"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-wander-orange/10 font-display text-base text-wander-orange"
        >
          {initial}
        </div>
        <div className="flex flex-col leading-tight">
          <span data-testid="topbar-user-name" className="font-display text-sm text-foreground">
            {user?.displayName ?? user?.email}
          </span>
          <span data-testid="topbar-user-role" className="brand-eyebrow !text-[10px]">
            {user?.role}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <LocaleSwitcher />
        <Button
          data-testid="sign-out-button"
          variant="ghost"
          size="sm"
          onClick={() => void signOut()}
          className="font-sans"
        >
          <LogOut className="h-4 w-4" />
          <span>{t("nav.signOut")}</span>
        </Button>
      </div>
    </header>
  );
}
